import $ from "jquery";
import axios from "axios";

(function () {
    const items_view = {
        init: function () {
            $('body').on('click', '.js-change-items-view', function (e) {
                e.preventDefault();
                const $this = $(this),
                    view = $this.data('view');

                axios.post(route('catalog.view'), {type: view})
                    .then(response => {
                        if (response.data.status === 'ok') {
                            location.reload();
                        }
                    });
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/items-view.js